import {
    createElementVNode as _$ce,
    className as _$cn,
    noop as _$no,
    createVNode as _$cv,
} from 'intact';
import {getRestProps} from '../utils';
import {makeStyles} from './styles';

var _$tmp0 = {
    'viewBox': '0 0 120 120'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {size, center, className, overlay, color, strokeWidth} = this.get();
    const { k } = this.config;
    
    const sw = strokeWidth || 6;
    const isNumericSize = typeof size === 'number';
    const canvasStyle = isNumericSize ? `width: ${size}px; height: ${size}px` : undefined;
    
    const classNameObj = {
        [`${k}-spin`]: true,
        [`${k}-${size}`]: !isNumericSize && size !== 'default',
        [`${k}-center`]: !overlay && center,
        [`${k}-overlay`]: overlay,
        [className]: className,
        [makeStyles(k, sw, color)]: true,
    };
    
    const canvas = (
        _$ce(2, 'div', (
            (
                (_$blocks['canvas'] = function($super) {
                    return (
                        _$ce(512, 'svg', (
                            _$ce(2, 'circle', null, 1, _$cn(`${k}-spin-circle`), {
                                'cx': '60',
                                'cy': '60',
                                'r': 60 - sw / 2
                            })
                        ), 2, null, _$tmp0)
                    );
                }),
                (__$blocks['canvas'] = function($super, data) {
                    var block = $blocks['canvas'];
                    var callBlock = function() {
                        return _$blocks['canvas'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                }),
                __$blocks['canvas'](_$no)
            )
        ), 0, _$cn(`${k}-spin-canvas`), {
            'style': canvasStyle
        })
    );
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, (
        (overlay) ?
            _$ce(2, 'div', canvas, 0, _$cn(`${k}-spin-wrapper`)) :
            canvas
    ));
};